export default {
  methods: {
    getOrderValue (sortValue) {
      if (sortValue && typeof sortValue === 'string') {
        if (sortValue.indexOf('desc') !== -1) {
          return '1'
        }
        if (sortValue.indexOf('asc') !== -1) {
          return '0'
        }
      }
      throw new Error('Unexpected value')
    },
    getSortValue (sortValue) {
      if (sortValue && typeof sortValue === 'string') {
        if (sortValue.indexOf('date') !== -1) {
          return 0
        }
        if (sortValue.indexOf('helpful') !== -1) {
          return 4
        }
        if (sortValue.indexOf('star') !== -1) {
          return 3
        }
      }
      throw new Error('Unexpected value')
    },
    getRefineValue (refineValue) {
      if (refineValue && typeof refineValue === 'string') {
        if (refineValue.indexOf('all') !== -1) {
          return undefined
        }
        if (refineValue.indexOf('5') !== -1) {
          return 5
        }
        if (refineValue.indexOf('4') !== -1) {
          return 4
        }
        if (refineValue.indexOf('3') !== -1) {
          return 3
        }
        if (refineValue.indexOf('2') !== -1) {
          return 2
        }
        if (refineValue.indexOf('1') !== -1) {
          return 1
        }
        if (refineValue.indexOf('0') !== -1) {
          return 0
        }
      }
      throw new Error('Unexpected value')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/sorts.js